import { useEffect } from "react";
import { useAppDispatch } from "../../../../../../../../store/config";
import { TrainingProgramsLayout } from "../../style";
import { Outlet } from "react-router-dom";
import { resetTrainingProgramWorkoutsTableState } from "../../../../../../../../store/features/training-program/training-program-slice";

export const TrainingProgramWorkouts = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetTrainingProgramWorkoutsTableState());
    };
  }, []);

  return (
    <TrainingProgramsLayout>
      <Outlet />
    </TrainingProgramsLayout>
  );
};
